import { render } from "./SideNavigation.vue?vue&type=template&id=78cb6610&scoped=true"
import script from "./SideNavigation.vue?vue&type=script&lang=js"
export * from "./SideNavigation.vue?vue&type=script&lang=js"

import "./SideNavigation.vue?vue&type=style&index=0&id=78cb6610&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78cb6610"]])

export default __exports__